import {
  AddPlanReq,
  ExpiryMode,
  ExerciseWindowUnit,
  ForfeitureSettings,
  StrikePriceType,
} from "../../types/EsopPlan";

export const defaultForfeitureSettings: ForfeitureSettings = {
  activeEmployee: {
    expiryMode: ExpiryMode.NEVER,
  },
  exitRules: [],
};

export const planInitValues: AddPlanReq = {
  id: undefined,
  planName: "",
  planType: "ESOP",
  planStartDate: "",
  poolSize: 0,
  planTerm: 0,
  planDescription: "",
  notes: "",
  vestingTemplateId: "",
  vestingTemplateName: "",
  isFractional: false,
  conversionNumber: 1,
  conversionShares: 1,
  poolShares: 0,
  isManagedByTrust: false,
  trustId: "",
  trustName: "",
  sharesManagedByTrust: 0,
  forfeitureSettings: defaultForfeitureSettings,
  unitName: "options",
  unitType: "ESOP",
  strikePriceType: StrikePriceType.OPTIONS_PRICE,
  noCashedOutPoolReturn: false,
};
